module.exports = __webpack_public_path__ + "static/media/main-banner.ec6160ae.png";